import React, { useState } from 'react';
import Tabs from '../../tabs';
import Detail from './pages/detail';
export default ({data, direction}) => {
    return (
        <div style={{display:'flex', flexDirection:'column'}}>
            <Tabs 
                selTab={0}
                tabs={[
                    {
                        id:0,
                        caption:'detail',
                        href:`/flight/domestic/${data._id}`,
                    },
                    {
                        id:1,
                        caption:'pnr',
                        href:`/flight/domestic/pnr/${data._id}`,
                    },
                    {
                        id:2, 
                        caption:'passengers',
                        href:`/flight/domestic/passengers/${data._id}`,
                    }
                ]}
            />
            <Detail data={data} />
        </div>
    )
}